import React, { useState, useEffect } from 'react'
import './search.css'
import { Collapse, Select, Radio } from "antd"
import { AiOutlinePlusSquare, AiOutlineMinusSquare } from "react-icons/ai"
import { Link } from 'react-router-dom'
import { heightList, religionAndCommunityList, languageList, qualificationList, workingWithList, occupationList } from "../../data"
import { countryAndcities } from '../../cities.js'
import { extractCastes } from '../../utilities/utilities'
import { useSelector } from 'react-redux'
import axios from "axios"
import key from '../../key'
import { useCookies } from "react-cookie"
import { PulseLoader } from 'react-spinners'
import { Modal } from 'react-bootstrap'

const { Option } = Select;
const { Panel } = Collapse;
function getCitiesByCountry(countryName) {
    let allCities = [];

    for (let i = 0; i < 152; i++) {
        if (countryAndcities[i].country_name === countryName) {
            allCities = countryAndcities[i].cities;
        }
    }
    return allCities;
}
const AdvancedSearch = () => {
    const { user } = useSelector(state => state.user)
    const [lookingFor, setLookingFor] = useState("")
    const [age1, setAge1] = useState(18)
    const [age2, setAge2] = useState(70)
    const [height1, setHeight1] = useState("4'0\"")
    const [height2, setHeight2] = useState("6'9\"")
    const [religion, setReligion] = useState(user?.personalDetails?.religion)
    const [maritalStatus, setMaritalStatus] = useState(user?.personalDetails?.maritalStatus)
    const [motherTongue, setMotherTongue] = useState(user?.personalDetails?.motherTongue)
    const [community, setCommunity] = useState(user?.personalDetails?.community)
    const [country, setCountry] = useState(user?.personalDetails?.countryLiving)
    const [cityLiving, setCityLiving] = useState(user?.personalDetails?.cityLiving)
    const [countryGrewUpIn, setCountryGrewUpIn] = useState(user?.personalDetails?.grewUpIn)
    const [qualification, setQualification] = useState(user?.educationAndCareer?.qualification)
    const [workingWith, setWorkingWith] = useState(user?.educationAndCareer?.workingWith)
    const [workingAs, setWorkingAs] = useState(user?.educationAndCareer?.occupation)
    const [diet, setDiet] = useState(user?.personalDetails?.diet)
    const [allCasts, setAllCasts] = useState([])
    const [citiesList, setCitiesList] = useState([]);
    const [showResults, setShowResults] = useState()
    const [loading, setLoading] = useState(false)
    const [show, setShow] = useState(false)

    //eslint-disable-next-line
    const [cookies, setCookie] = useCookies(['x-auth-token']);

    const handleClose = () => setShow(false);
    const handleSearch = async () => {
        let gend;
        if (user?.gender === "Male") {
            gend = "Female"
        } else if (user?.gender === "Female") {
            gend = "Male"
        }
        let oppositeItems = [];
        for (const item of lookingFor) {
          if (gend === "Male" && item === 'Groom/Bride') {
              oppositeItems.push('Bride');
          } else if (gend === 'Male' && item === 'Boy Friend/Girl Friend') {
              oppositeItems.push('Girl Friend');
          } else if (gend === "Female" && item === 'Groom/Bride') {
              oppositeItems.push('Groom');
          } else if (gend === 'Female' && item === 'Boy Friend/Girl Friend') {
              oppositeItems.push('Boy Friend');
          }
      }
        let values = {
            lookingFor: oppositeItems,
            gender: gend,
            age1,
            age2,
            height1,
            height2,
            religion,
            maritalStatus,
            motherTongue,
            community,
            countryLiving: country,
            cityLiving,
            grewUpIn: countryGrewUpIn,
            qualification,
            workingWith,
            occupation: workingAs,
            diet
        }
        setShow(true)

        try {
            setLoading(true)
            const res = await axios.post(`${key}/api/user/advance-search`, values, {
                headers: {
                    "x-auth-token": cookies["x-auth-token"]
                }
            });
            if (res?.data?.results?.length === 0) {
                setShowResults(null)
            } else {
                setShowResults(res?.data?.results)
            }
            setLoading(false)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        setAllCasts(extractCastes())
    }, [])
    const getCities = (value) => {
        setCountry(value)
        setCitiesList(getCitiesByCountry(value));
    }
    return (
        <div className='container'>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Search Result</Modal.Title>
                </Modal.Header>
                {loading ? <Modal.Body> <div className="loading-spinner"><PulseLoader size={25} color="#fa585b" /></div> </Modal.Body> : <Modal.Body>
                    {showResults ? showResults?.map((result, index) => (
                        <div key={index} className="main-search-card row">
                            <div className="col-md-5">
                                <div>{result?.userId}</div>
                            </div>
                            <div className="col-md-4">
                                <div>{result?.firstName} {result?.lastName}</div>
                            </div>
                            <div className="col-md-3">
                                <Link to={`/view-profile/${result?._id}`}>View Profile</Link>
                            </div>
                        </div>
                    )) : <Modal.Body> <div className="text-center">No Results Found</div></Modal.Body>}
                </Modal.Body>}
            </Modal>
            <div className='AdvancedSearch backgroundLight'>
                <div className='row'>
                    <div className="col-md-4">Looking For</div>
                    <div className="col-md-8">
                        <Select mode='multiple' placeholder="You are Looking for" style={{ width: 600 }} onChange={(e) => setLookingFor(e)}>
                            <Option value="Groom/Bride">Groom/Bride</Option>
                            <Option value="Boy Friend/Girl Friend">Boy Friend/Girl Friend </Option>
                        </Select>
                    </div>

                    <div className='listtt'></div>
                    <div className="col-md-4">Age</div>
                    <div className="col-md-8">
                        <Select style={{ width: 100 }} onChange={(e) => setAge1(e)} defaultValue={"18"}>
                            {Array.from({ length: 70 - 18 + 1 }, (_, i) => i + 18).map((age) => (
                                <Option key={age} value={age}>
                                    {age}
                                </Option>
                            ))}
                        </Select>
                        <span> to </span>
                        <Select style={{ width: 100 }} onChange={(e) => setAge2(e)} defaultValue={"70"}>
                            {Array.from({ length: 70 - 18 + 1 }, (_, i) => i + 18).map((age) => (
                                <Option key={age} value={age}>
                                    {age}
                                </Option>
                            ))}
                        </Select>
                    </div>
                    <div className='listtt'></div>

                    <div className="col-md-4">Height</div>
                    <div className="col-md-8">
                        <Select style={{ width: 100 }} onChange={(e) => setHeight1(e)} defaultValue={"4'0\""}>
                            {heightList.map((height, index) => (
                                <Option key={index} value={height}>
                                    {height}
                                </Option>
                            ))}
                        </Select>
                        <span> to </span>
                        <Select style={{ width: 100 }} onChange={(e) => setHeight2(e)} defaultValue={"6'9\""}>
                            {heightList.map((height, index) => (
                                <Option key={index} value={height}>
                                    {height}
                                </Option>
                            ))}
                        </Select>
                    </div>
                    <div className='listtt'></div>

                    <div className="col-md-4">Marital Status</div>
                    <div className="col-md-8">
                        <Select style={{ width: 600 }} onChange={(e) => setMaritalStatus(e)} defaultValue={user?.personalDetails?.maritalStatus}>
                            <Option value="Never Married">Never Married</Option>
                            <Option value="Divorced">Divorced</Option>
                            <Option value="Widowed">Widowed</Option>
                            <Option value="Awaiting Divorce">Awaiting Divorce</Option>
                            <Option value="Annulled">Annulled</Option>
                        </Select>
                    </div>

                    <div className='listtt'></div>

                    <div className="col-md-4">Religion</div>
                    <div className="col-md-8">
                        <Select showSearch style={{ width: 600 }} onChange={(e) => setReligion(e)} defaultValue={user?.personalDetails?.religion}>
                            {
                                religionAndCommunityList.map((religionAndCommunity, index) => (
                                    <Option key={index} value={religionAndCommunity.religion}>{religionAndCommunity.religion}</Option>
                                ))
                            }
                        </Select>
                    </div>

                    <div className='listtt'></div>

                    <div className="col-md-4">Mother Tongue</div>
                    <div className="col-md-8">
                        <Select showSearch style={{ width: 600 }} onChange={(e) => setMotherTongue(e)} defaultValue={user?.personalDetails?.motherTongue}>
                            {languageList.map((language, index) => (
                                <Option key={index} value={language}>
                                    {language}
                                </Option>
                            ))}
                        </Select>
                    </div>


                    <div className='listtt'></div>

                    <div className="col-md-4">Community</div>
                    <div className="col-md-8">
                        <Select showSearch style={{ width: 600 }} onChange={(e) => setCommunity(e)} defaultValue={user?.personalDetails?.community}>
                            {allCasts.map((community, index) => (
                                <Option key={index} value={community}>
                                    {community}
                                </Option>
                            ))}
                        </Select>
                    </div>


                    <div className='listtt'></div>


                    <Collapse
                        style={{ background: "transparent" }}
                        bordered={false}
                        expandIcon={({ isActive }) => isActive ? <AiOutlineMinusSquare size={27} /> : <AiOutlinePlusSquare size={27} />}
                    >
                        <Panel header="Location & Grew up in Details" key="1" style={{ marginBottom: 24, background: "#e2e2df", border: 'none' }}>
                            <div className='row'>
                                <div className='listtt'></div>
                                <div className="col-md-4">Country Living In</div>
                                <div className="col-md-8">
                                    <Select showSearch style={{ width: 600 }} onChange={(e) => getCities(e)} defaultValue={user?.personalDetails?.countryLiving}>
                                        {countryAndcities.map((country, index) => (
                                            <Option key={index} value={country.country_name}>
                                                {country.country_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                <div className='listtt'></div>
                                <div className="col-md-4">City Living In</div>
                                <div className="col-md-8">
                                    <Select style={{ width: 600 }} onChange={(e) => setCityLiving(e)} defaultValue={user.personalDetails.cityLiving} showSearch>
                                        {
                                            citiesList?.map((city, index) => (
                                                <Option key={index} value={city}>{city}</Option>
                                            ))
                                        }
                                    </Select>
                                </div>
                                <div className='listtt'></div>
                                <div className="col-md-4">Country GrewUp In</div>
                                <div className="col-md-8">
                                    <Select showSearch style={{ width: 600 }} onChange={(e) => setCountryGrewUpIn(e)} defaultValue={user?.personalDetails?.grewUpIn}>
                                        {countryAndcities.map((country, index) => (
                                            <Option key={index} value={country.country_name}>
                                                {country.country_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Education & Profession Details" key="2" style={{ marginBottom: 24, background: "#e2e2df", border: 'none' }}>
                            <div className='row'>
                                <div className='listtt'></div>
                                <div className="col-md-4">Qualification</div>
                                <div className="col-md-8">
                                    <Select showSearch style={{ width: 600 }} onChange={(e) => setQualification(e)} defaultValue={user?.educationAndCareer?.qualification}>
                                        {qualificationList.map((qualification, index) => (
                                            <Option key={index} value={qualification}>
                                                {qualification}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>

                                <div className='listtt'></div>
                                <div className="col-md-4">Working With</div>
                                <div className="col-md-8">
                                    <Select showSearch style={{ width: 600 }} onChange={(e) => setWorkingWith(e)} defaultValue={user?.educationAndCareer?.workingWith}>
                                        {workingWithList.map((workingWith, index) => (
                                            <Option key={index} value={workingWith}>
                                                {workingWith}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                <div className='listtt'></div>
                                <div className="col-md-4">Occupation</div>
                                <div className="col-md-8">
                                    <Select showSearch style={{ width: 600 }} onChange={(e) => setWorkingAs(e)} defaultValue={user?.educationAndCareer?.occupation}>
                                        {occupationList.map((occupation, index) => (
                                            <Option key={index} value={occupation}>
                                                {occupation}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Lifestyle & Appearance" key="3" style={{ marginBottom: 24, background: "#e2e2df", border: 'none' }}>
                            <div className='row'>
                                <div className='listtt'></div>
                                <div className="col-md-4">Diet</div>
                                <div className="col-md-8">
                                    <Select showSearch style={{ width: 600 }} onChange={(e) => setDiet(e)} defaultValue={user?.personalDetails?.diet}>
                                        <Radio value="Veg">Veg</Radio>
                                        <Radio value="Occasionally Veg">Occasionally Veg</Radio>
                                        <Radio value="Non-Veg">Non-Veg</Radio>
                                        <Radio value="Occasionally Non-Veg">Occasionally Non-Veg</Radio>
                                        <Radio value="Eggetarian">Eggetarian</Radio>
                                        <Radio value="Jain">Jain</Radio>
                                        <Radio value="Vegan">Vegan</Radio>
                                        <Radio value="Other">Other</Radio>
                                    </Select>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>

                    <div className='d-flex justify-content-center'>
                        <Link className='btn btn-outline-warning customBtn' onClick={handleSearch}>
                            Search
                        </Link>
                        {/* <Link className='mt-2' style={{ marginLeft: 10 }}>Reset</Link> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdvancedSearch
